import React, { useState, useEffect, useRef } from "react";
import ModifyRecipient from "./ModifyRecipient";
import Utils from "../../../utils";
import { getRecipientList, recipientDetail } from "../../../services/Recipients";
import { toast } from "react-toastify";
import Pagination from "react-js-pagination";
import DeleteRecipient from "./Delete";
import Recipientsimport from "./Recipientsimport";
import Dropdown from 'rc-dropdown';
import Menu, { Item as MenuItem } from 'rc-menu';

const lengths = Utils.tableShowLengths();

function Recipients() {
  const addButtonRef = useRef(null);
  const delButtonRef = useRef(null);

  const [loading, setLoading] = useState(false);
  const [isLoad, setIsLoad] = useState(true);
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState('');
  const [isEffect, setIsEffect] = useState(false);
  const [list, setList] = useState([]);
  const [listProcess, setListProcess] = useState('loading...');
  const [totalRecipient, setTotalRecipient] = useState(0);
  const [delId, setDelId] = useState(0);
  const [data, setData] = useState({
    id: 0,
    first_name: '',
    last_name: '',
    email: '',
    country_id: 227,
    mobile: '',
    company_name: '',
    address_1: '',
    address_2: '',
    city: '',
    state: '',
    address_country_id: '',
    zipcode: '',
    readonly: false
  });
  const [openDropdown, setOpenDropdown] = useState(null);

  useEffect(() => {
    if (isLoad) {
      setLoading(true);
    }
    setListProcess('loading...');
    setList([]);
    let obj = {
      limit: limit,
      search: search,
      page: page
    };
    getRecipientList(obj)
      .then(response => {
        if (response.data) {
          setTotalRecipient(parseInt(response.data.count));
          setList(response.data.data);

          if (response.data.data.length === 0) {
            setListProcess('No data available.');
          }
        }
        setLoading(false);
        setIsLoad(false);
      })
      .catch(err => {
        setLoading(false);
        setIsLoad(false);
        toast.error(Utils.getErrorMessage(err));
      });
  }, [limit, search, page, isEffect, isLoad]);

  const handleTableLength = (e) => {
    setPage(1);
    setLimit(parseInt(e.target.value));
  };

  const handleSearch = (e) => {
    setPage(1);
    setSearch(e.target.value);
  };

  const onEditRecipient = (e, data) => {
    e.preventDefault();
    setLoading(true);
    recipientDetail({ id: data.id })
      .then(response => {
        let detail = response.data.data;
        let obj = {
          id: detail.id,
          first_name: detail.first_name,
          last_name: detail.last_name,
          email: detail.email,
          country_id: detail.country_id,
          mobile: detail.mobile,
          company_name: (detail.company_name) ? detail.company_name : '',
          address_1: (detail.address_1) ? detail.address_1 : '',
          address_2: (detail.address_2) ? detail.address_2 : '',
          city: (detail.city) ? detail.city : '',
          state: (detail.state) ? detail.state : '',
          address_country_id: (detail.address_country_id) ? detail.address_country_id : '',
          zipcode: (detail.zip_code) ? detail.zip_code : '',
          readonly: false
        };
        setData(obj);
        addButtonRef.current?.click();
        setLoading(false);
      })
      .catch(err => {
        toast.error(Utils.getErrorMessage(err));
        setLoading(true);
      });
  };

  const onViewRecipient = (e, data) => {
    e.preventDefault();
    setLoading(true);
    recipientDetail({ id: data.id })
      .then(response => {
        let detail = response.data.data;
        let obj = {
          id: detail.id,
          first_name: detail.first_name,
          last_name: detail.last_name,
          email: detail.email,
          country_id: detail.country_id,
          mobile: detail.mobile,
          company_name: (detail.company_name) ? detail.company_name : '',
          address_1: (detail.address_1) ? detail.address_1 : '',
          address_2: (detail.address_2) ? detail.address_2 : '',
          city: (detail.city) ? detail.city : '',
          state: (detail.state) ? detail.state : '',
          address_country_id: (detail.address_country_id) ? detail.address_country_id : '',
          zipcode: (detail.zip_code) ? detail.zip_code : '',
          readonly: true
        };
        setData(obj);
        addButtonRef.current?.click();
        setLoading(false);
      })
      .catch(err => {
        toast.error(Utils.getErrorMessage(err));
        setLoading(true);
      });
  };

  const onDeleteRecipient = (e, data) => {
    e.preventDefault();
    delButtonRef.current?.click();
    setDelId(data.id);
  };

  return (
    <>
      {loading && <div className="page-loading">
        <img src="/images/loader.gif" alt="loader" />
      </div>}
      <section className="main_wrapper section-bg-color recipient_page"
        style={{ minHeight: 'calc(100vh - 54.5px)', paddingTop: "70px" }}>
        <div className="custom_container">


          <div className="recipients-header">
            <div>
              <h2>Recipients</h2>
              <p>Manage your document recipients</p>
            </div>
            <div className="recipients-actions">
              <Recipientsimport setIsEffect={setIsEffect} />
              <button
                type="button"
                className="Add_recipient"
                ref={addButtonRef}
                data-bs-toggle="offcanvas"
                data-bs-target="#addRecipients"
                data-bs-backdrop="true"
              >
                <span>+</span> Add Recipient
              </button>
            </div>
          </div>

          <div className="recipients-table-wrapper">
            <div className="recipients-search">
              <input
                type="text"
                value={search}
                onChange={handleSearch}
                placeholder="Search Recipients"
              />
              <i className="bi bi-search search-icon" />
            </div>
            <table className="recipients-table">
              <thead className="table-light">
                <tr>
                  <th>Created</th>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Mobile</th>
                  <th>Company</th>
                  <th>User</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {list.length > 0 ? (
                  list.map((item, i) => {
                    const menu = (
                      <Menu
                        className="custom-rc-dropdown-menu"
                        onClick={({ key }) => {
                          if (key === 'view') onViewRecipient({ preventDefault: () => { } }, item);
                          if (key === 'edit') onEditRecipient({ preventDefault: () => { } }, item);
                          if (key === 'delete') onDeleteRecipient({ preventDefault: () => { } }, item);
                        }}
                      >
                        <MenuItem key="view" className="custom-rc-dropdown-item"><i className="bi bi-eye me-1"></i>View</MenuItem>
                        <MenuItem key="edit" className="custom-rc-dropdown-item"><i className="bi bi-pencil-fill me-1"></i>Edit</MenuItem>
                        <MenuItem key="delete" className="custom-rc-dropdown-delete custom-rc-dropdown-item"><i className="bi bi-trash me-1"></i>Delete</MenuItem>
                      </Menu>
                    );
                    return (
                      <tr key={i}>
                        <td>{item.created_at}</td>
                        <td>{item.first_name} {item.last_name}</td>
                        <td>{item.email}</td>
                        <td>{item.mobile ? `+${item.country_code} ${item.mobile}` : '-'}</td>
                        <td>{item.company_name || '-'}</td>
                        <td>{item.user_by}</td>
                        <td style={{ minWidth: 60, textAlign: 'center' }}>
                          <Dropdown
                            trigger={["click"]}
                            overlay={menu}
                            animation="slide-up"
                            placement="bottomRight"
                          >
                            <span style={{ cursor: 'pointer', display: 'inline-flex', alignItems: 'center', height: '32px' }}>
                              <i className="bi bi-three-dots-vertical" style={{ fontSize: 20 }}></i>
                            </span>
                          </Dropdown>
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan={7} className="text-center">{listProcess}</td>
                  </tr>
                )}
              </tbody>
            </table>

            <div className="recipients-footer">
              <div>
                <span>Show</span>
                <select value={limit} onChange={handleTableLength}>
                  {lengths.map((item, i) => (
                    <option value={item} key={i}>{item}</option>
                  ))}
                </select>
              </div>
              <Pagination
                activePage={page}
                itemsCountPerPage={limit}
                totalItemsCount={totalRecipient}
                pageRangeDisplayed={5}
                onChange={setPage}
              />
            </div>
          </div>

          {/* Modals and Offcanvas */}
          <button
            type="button"
            ref={delButtonRef}
            className="d-none"
            data-bs-toggle="modal"
            data-bs-target="#deleteModal"
          />
          <DeleteRecipient delId={delId} setDelId={setDelId} isEffect={isEffect} setIsEffect={setIsEffect} />
          <ModifyRecipient data={data} isEffect={isEffect} setIsEffect={setIsEffect} setData={setData} setLoading={setLoading} />
        </div>
      </section>
    </>
  )
}

export default Recipients;